import type { EdbSalesMode } from '@/types/api'
import type { InvoiceInfo } from '@/types/invoice'

/** 改時間狀態 */
export const RescheduleStatusEnum = Object.freeze({
  /** 0: 可以改時間 */
  Reschedulable: 0,
  /** 1: 不能改時間，原因：離出發時間太短 */
  'Unreschedulable:Time': 1,
  /** 2: 已改過時間 */
  Rescheduled: 2,
  /** 3: 不能改時間，原因：方案不可改時間 */
  'Unreschedulable:Product': 3,
  /** 4: 不能改時間，原因：訂單已兌換 */
  'Unreschedulable:OrderRedeemed': 4,
  /** 5: 不能改時間，原因：訂單取消 */
  'Unreschedulable:Canceled': 5,
  /** 6: 不能改時間，原因：揪團子訂單不可改時間 */
  'Unreschedulable:GroupMember': 6,
})

/** 訂單揪團角色 */
export const OrderGroupRole = Object.freeze({
  /** 0: 非揪團訂單 */
  NoneGroupOrder: 0,
  /** 1: 揪團訂單擁有者 */
  GroupOrderOwner: 1,
  /** 2: 揪團訂單跟單者 */
  GroupOrderFollower: 2,
})

/** 改時間 modal 步驟 */
export enum RescheduleModalStep {
  Remind = 'remind',
  Reschedule = 'reschedule',
  Seats = 'seats',
  Reconfirm = 'reconfirm',
  ErrorGetRescheduleError = 'error:getRescheduleError',
  ErrorUpdateRescheduleError = 'error:updateRescheduleError',
}

/** 訂單來源 */
export enum OrderSource {
  /** 0 = FunNow */
  FunNow,
  /** 1 = Line coupon */
  LineCoupon,
  /** 2 = Line spot(合作終止) */
  LineSpot,
  /** 3 = ezbook */
  EzBook,
  /** 4 = Booking Engine */
  BookingEngine,
  /** 5 = Partner ( PCHome... ) */
  Partner,
  /** 6 = FunBook 2.0 */
  FunBookV2,
  /** Niceday */
  Niceday,
}

/** 訂單一般狀態 */
export const OrderCommonStatus = Object.freeze({
  BookingSuccess: 'booking-success',
  Redeem: 'redeem',
  Commented: 'commented',
  Cancel: 'cancel',
  Cert: 'cert',
})

/** 電影訂單狀態 0: 預訂完成, 1: 已開演, 2: 已評論, 3: 已取消 */
export const OrderMovieStatus = Object.freeze({
  /** 0: 預訂完成 */
  BookingSuccess: 0,
  /** 1: 已開演 */
  Redeem: 1,
  /** 2: 已評論 */
  Commented: 2,
  /** 3: 已取消 */
  Cancel: 3,
})

/** 訂單 是在哪個平台訂的 */
export const OrderPlatformType = Object.freeze({
  FunNow: 1,
  /** FunBook v1 order */
  Reservation: 2,
  /** FunBook v2 order */
  FunBookV2: 3,
})

/**
 * order detail status 個別狀態資料 map
 */
export const OrderDetailStatusMap = {
  /** 取消 */
  Cancel: {
    icon: 'cancel-icon_white.svg',
    text: 'bookinglist_cancelled',
    active: false,
    cancel: true,
  },
  /** 預訂完成 */
  Booked: {
    icon: 'check-icon_white.svg',
    text: 'order_status_booked',
    active: true,
    cancel: false,
  },
  /** 預約完成 酒類使用，web 不會顯示酒類業 */
  Reserved: {
    icon: 'check-icon_white.svg',
    text: '預約完成',
    active: true,
    cancel: false,
  },
  /** 憑證等待中 */
  CertWaiting: {
    icon: '',
    text: 'order_status_waiting_voucher',
    active: false,
    cancel: false,
  },
  /** 憑證可供下載 */
  CertCreated: {
    icon: 'scanning-icon_white.svg',
    text: 'bookinglist_download_voucher',
    active: true,
    cancel: false,
  },
  /** 未送達 */
  Undelivered: {
    icon: '',
    text: 'order_status_undeliver',
    active: false,
    cancel: false,
  },
  /** 已送達 */
  Arrived: {
    icon: 'motorcycle.svg',
    text: 'bookinglist_delivered',
    active: true,
    cancel: false,
  },
  /** 未兌換 */
  NotRedeemed: {
    icon: '',
    text: 'order_status_unredeem',
    active: false,
    cancel: false,
  },
  /** 已兌換 / 已過期 */
  Redeemed: {
    icon: 'scanning-icon_white.svg',
    text: 'order_status_redeemed',
    active: true,
    cancel: false,
  },
  PureRedeemed: {
    icon: 'scanning-icon_white.svg',
    text: 'order_status_redeemed_reservation_only',
    active: true,
    cancel: false,
  },
  /** 已開演 */
  TheShowStarted: {
    icon: 'scanning-icon_white.svg',
    text: 'movie_started',
    active: true,
    cancel: false,
  },
  /** 未開演 */
  TheShowNotStarted: {
    icon: '',
    text: 'movie_not_started',
    active: false,
    cancel: false,
  },
  /** 已報到 */
  InNew: {
    icon: 'check-icon_white.svg',
    text: 'order_status_in_new',
    active: true,
    cancel: false,
  },
  /** 未報到 */
  NotInNew: {
    icon: '',
    text: 'order_status_not_in_new',
    active: false,
    cancel: false,
  },
  /** 已報到 / 已過期 */
  RedeemNew: {
    icon: 'scanning-icon_white.svg',
    text: 'order_status_redeem_new',
    active: true,
    cancel: false,
  },
  /** 已過期 */
  Expired: {
    icon: 'alert-circle.svg',
    text: 'order_status_expired',
    active: true,
    cancel: false,
  },
  /** 未評論 */
  Uncommented: {
    icon: '',
    text: 'order_status_uncomment',
    active: false,
    cancel: false,
  },
  /** 已評論 */
  Commented: {
    icon: 'star-outline_white.svg',
    text: 'order_status_commented',
    active: true,
    cancel: false,
  },
  /** 未付款 */
  Unpaid: {
    icon: '',
    text: 'order_status_unpaid',
    active: false,
    cancel: false,
  },
  /** 未出席 */
  NoShow: {
    icon: 'alert-circle.svg',
    text: 'order_status_no_show',
    active: true,
    cancel: false,
  },
}

/** 訂單詳細狀態顯示枚舉 */
export enum OrderDetailDisplayStatus {
  /** 預訂完成、未兌換、未評論 */
  BOOKED_NOT_REDEEMED_UNCOMMENTED = 0,
  /** 預訂完成、憑證等待中、未評論 */
  BOOKED_CERT_WAITING_UNCOMMENTED = 1,
  /** 預訂完成、未送達、未評論 */
  BOOKED_UNDELIVERED_UNCOMMENTED = 2,
  /** 預約完成、未兌換、未評論 */
  RESERVED_NOT_REDEEMED_UNCOMMENTED = 3,
  /** 預訂完成、未開演、未評論 */
  BOOKED_SHOW_NOT_STARTED_UNCOMMENTED = 4,
  /** 預訂完成、已兌換/已過期、未評論 */
  BOOKED_REDEEMED_UNCOMMENTED = 5,
  /** 預訂完成、憑證可供下載、未評論 */
  BOOKED_CERT_CREATED_UNCOMMENTED = 6,
  /** 預訂完成、已送達、未評論 */
  BOOKED_ARRIVED_UNCOMMENTED = 7,
  /** 預約完成、已兌換/已過期、未評論 */
  RESERVED_REDEEMED_UNCOMMENTED = 8,
  /** 預訂完成、已開演、未評論 */
  BOOKED_SHOW_STARTED_UNCOMMENTED = 9,
  /** 預訂完成、已兌換/已過期、已評論 */
  BOOKED_REDEEMED_COMMENTED = 10,
  /** 預訂完成、憑證可供下載、已評論 */
  BOOKED_CERT_CREATED_COMMENTED = 11,
  /** 預訂完成、已送達、已評論 */
  BOOKED_ARRIVED_COMMENTED = 12,
  /** 預約完成、已兌換/已過期、已評論 */
  RESERVED_REDEEMED_COMMENTED = 13,
  /** 預訂完成、已開演、已評論 */
  BOOKED_SHOW_STARTED_COMMENTED = 14,
  /** 預訂完成、未報到 */
  BOOKED_NOT_IN = 15,
  /** 預訂完成、已報到 */
  BOOKED_IN = 16,
  /** 預訂完成、已過期 */
  BOOKED_EXPIRED = 17,
  /** 預訂完成、已報到/已過期 */
  BOOKED_REDEEM_NEW = 18,
  /** 訂單取消 */
  CANCEL = 19,
  /** 預約單取消 (酒類業使用，web 不顯示酒類業) */
  RESERVATION_CANCEL = 20,
  /** 未付款、未報到 */
  UNPAID_NOT_IN = 21,
  /** 預訂完成、已兌換、未評論 */
  BOOKED_PURE_REDEEMED_UNCOMMENTED = 22,
  /** 預訂完成、已兌換、已評論 */
  BOOKED_PURE_REDEEMED_COMMENTED = 23,
  /** 預訂完成、未出席 */
  BOOKED_NO_SHOW = 24,
}

/**
 * order detail status for display
 * 每種狀態 ( 兩個 或 三個 ) 的對應表
 * https://github.com/funnow-docs/funnow-api-doc/pull/87
 */
export const OrderDetailDisplayStatusMap = Object.freeze({
  /** 0: 預訂完成、未兌換、未評論 */
  [OrderDetailDisplayStatus.BOOKED_NOT_REDEEMED_UNCOMMENTED]: [
    OrderDetailStatusMap.Booked,
    OrderDetailStatusMap.NotRedeemed,
    OrderDetailStatusMap.Uncommented,
  ],
  /** 1: 預訂完成、憑證等待中、未評論 */
  [OrderDetailDisplayStatus.BOOKED_CERT_WAITING_UNCOMMENTED]: [
    OrderDetailStatusMap.Booked,
    OrderDetailStatusMap.CertWaiting,
    OrderDetailStatusMap.Uncommented,
  ],
  /** 2: 預訂完成、未送達、未評論 */
  [OrderDetailDisplayStatus.BOOKED_UNDELIVERED_UNCOMMENTED]: [
    OrderDetailStatusMap.Booked,
    OrderDetailStatusMap.Undelivered,
    OrderDetailStatusMap.Uncommented,
  ],
  /** 3: 預約完成、未兌換、未評論 */
  [OrderDetailDisplayStatus.RESERVED_NOT_REDEEMED_UNCOMMENTED]: [
    OrderDetailStatusMap.Reserved,
    OrderDetailStatusMap.NotRedeemed,
    OrderDetailStatusMap.Uncommented,
  ],
  /** 4: 預訂完成、未開演、未評論 */
  [OrderDetailDisplayStatus.BOOKED_SHOW_NOT_STARTED_UNCOMMENTED]: [
    OrderDetailStatusMap.Booked,
    OrderDetailStatusMap.TheShowNotStarted,
    OrderDetailStatusMap.Uncommented,
  ],
  /** 5: 預訂完成、已兌換/已過期、未評論 */
  [OrderDetailDisplayStatus.BOOKED_REDEEMED_UNCOMMENTED]: [
    OrderDetailStatusMap.Booked,
    OrderDetailStatusMap.Redeemed,
    OrderDetailStatusMap.Uncommented,
  ],
  /** 6: 預訂完成、憑證可供下載、未評論 */
  [OrderDetailDisplayStatus.BOOKED_CERT_CREATED_UNCOMMENTED]: [
    OrderDetailStatusMap.Booked,
    OrderDetailStatusMap.CertCreated,
    OrderDetailStatusMap.Uncommented,
  ],
  /** 7: 預訂完成、已送達、未評論 */
  [OrderDetailDisplayStatus.BOOKED_ARRIVED_UNCOMMENTED]: [
    OrderDetailStatusMap.Booked,
    OrderDetailStatusMap.Arrived,
    OrderDetailStatusMap.Uncommented,
  ],
  /** 8: 預約完成、已兌換/已過期、未評論 */
  [OrderDetailDisplayStatus.RESERVED_REDEEMED_UNCOMMENTED]: [
    OrderDetailStatusMap.Reserved,
    OrderDetailStatusMap.Redeemed,
    OrderDetailStatusMap.Uncommented,
  ],
  /** 9: 預訂完成、已開演、未評論 */
  [OrderDetailDisplayStatus.BOOKED_SHOW_STARTED_UNCOMMENTED]: [
    OrderDetailStatusMap.Booked,
    OrderDetailStatusMap.TheShowStarted,
    OrderDetailStatusMap.Uncommented,
  ],
  /** 10: 預訂完成、已兌換/已過期、已評論 */
  [OrderDetailDisplayStatus.BOOKED_REDEEMED_COMMENTED]: [OrderDetailStatusMap.Booked, OrderDetailStatusMap.Redeemed, OrderDetailStatusMap.Commented],
  /** 11: 預訂完成、憑證可供下載、已評論 */
  [OrderDetailDisplayStatus.BOOKED_CERT_CREATED_COMMENTED]: [
    OrderDetailStatusMap.Booked,
    OrderDetailStatusMap.CertCreated,
    OrderDetailStatusMap.Commented,
  ],
  /** 12: 預訂完成、已送達、已評論 */
  [OrderDetailDisplayStatus.BOOKED_ARRIVED_COMMENTED]: [OrderDetailStatusMap.Booked, OrderDetailStatusMap.Arrived, OrderDetailStatusMap.Commented],
  /** 13: 預約完成、已兌換/已過期、已評論 */
  [OrderDetailDisplayStatus.RESERVED_REDEEMED_COMMENTED]: [
    OrderDetailStatusMap.Reserved,
    OrderDetailStatusMap.Redeemed,
    OrderDetailStatusMap.Commented,
  ],
  /** 14: 預訂完成、已開演、已評論 */
  [OrderDetailDisplayStatus.BOOKED_SHOW_STARTED_COMMENTED]: [
    OrderDetailStatusMap.Booked,
    OrderDetailStatusMap.TheShowStarted,
    OrderDetailStatusMap.Commented,
  ],
  /** 15: 預訂完成、未報到 */
  [OrderDetailDisplayStatus.BOOKED_NOT_IN]: [OrderDetailStatusMap.Booked, OrderDetailStatusMap.NotInNew],
  /** 16: 預訂完成、已報到 */
  [OrderDetailDisplayStatus.BOOKED_IN]: [OrderDetailStatusMap.Booked, OrderDetailStatusMap.InNew],
  /** 17: 預訂完成、已過期 */
  [OrderDetailDisplayStatus.BOOKED_EXPIRED]: [OrderDetailStatusMap.Booked, OrderDetailStatusMap.Expired],
  /** 18: 預訂完成、已報到/已過期 */
  [OrderDetailDisplayStatus.BOOKED_REDEEM_NEW]: [OrderDetailStatusMap.Booked, OrderDetailStatusMap.RedeemNew],
  /** 19: 訂單取消 */
  [OrderDetailDisplayStatus.CANCEL]: [OrderDetailStatusMap.Cancel],
  /** 20: 預約單取消 (酒類業使用，web 不顯示酒類業) */
  [OrderDetailDisplayStatus.RESERVATION_CANCEL]: [],
  /** 21: 未付款、未報到 */
  [OrderDetailDisplayStatus.UNPAID_NOT_IN]: [OrderDetailStatusMap.Unpaid, OrderDetailStatusMap.NotInNew],
  /** 22: 預訂完成、已兌換、未評論 */
  [OrderDetailDisplayStatus.BOOKED_PURE_REDEEMED_UNCOMMENTED]: [
    OrderDetailStatusMap.Booked,
    OrderDetailStatusMap.PureRedeemed,
    OrderDetailStatusMap.Uncommented,
  ],
  /** 23: 預訂完成、已兌換、已評論 */
  [OrderDetailDisplayStatus.BOOKED_PURE_REDEEMED_COMMENTED]: [
    OrderDetailStatusMap.Booked,
    OrderDetailStatusMap.PureRedeemed,
    OrderDetailStatusMap.Commented,
  ],
  /** 24: 預訂完成、未出席 */
  [OrderDetailDisplayStatus.BOOKED_NO_SHOW]: [OrderDetailStatusMap.Booked, OrderDetailStatusMap.NoShow],
})

/** 根據上面的 order 狀態，當 order status為 0, 1, 2, 3, 4, 15 ，也就是訂單已預訂尚未兌換時表單有效 */
export const validOrderStatesForAttendeeForm = Object.freeze([
  OrderDetailDisplayStatus.BOOKED_NOT_REDEEMED_UNCOMMENTED,
  OrderDetailDisplayStatus.BOOKED_CERT_WAITING_UNCOMMENTED,
  OrderDetailDisplayStatus.BOOKED_UNDELIVERED_UNCOMMENTED,
  OrderDetailDisplayStatus.RESERVED_NOT_REDEEMED_UNCOMMENTED,
  OrderDetailDisplayStatus.BOOKED_SHOW_NOT_STARTED_UNCOMMENTED,
  OrderDetailDisplayStatus.BOOKED_NOT_IN,
])

export const OrderTagStatusMap = {
  /** 已取消 */
  Cancel: {
    text: 'bookinglist_cancelled',
    bgColor: 'wd-bg-gray80',
  },
  /** 已送達 */
  Arrived: {
    text: 'order_status_delivered',
    bgColor: 'wd-bg-green70',
  },
  /** 已開演 */
  TheShowStarted: {
    text: 'movie_started',
    bgColor: 'wd-bg-green70',
  },
  /** 已兌換 */
  Redeemed: {
    text: 'bookinglist_redeemed_expired',
    bgColor: 'wd-bg-green70',
  },
  /** 已更改預訂時間 */
  Rescheduled: {
    text: 'bookinglist_recheduled',
    bgColor: 'wd-bg-green70',
  },
  /** 預訂完成 */
  Booked: {
    text: 'bookinglist_booking_completed',
    bgColor: 'wd-bg-orange50',
  },
  /** 憑證可供下載 */
  CertCreated: {
    text: 'bookinglist_download_voucher',
    bgColor: 'wd-bg-green70',
  },
  /** 已評論 */
  Commented: {
    text: 'bookinglist_commented',
    bgColor: 'wd-bg-green70',
  },
  /** 已報到 */
  InNew: {
    text: 'order_status_in_new',
    bgColor: 'wd-bg-green70',
  },
  /** 已報到/已過期 */
  RedeemNew: {
    text: 'order_status_redeem_new',
    bgColor: 'wd-bg-green70',
  },
  /** 已過期 */
  Expired: {
    text: 'order_status_expired',
    bgColor: 'wd-bg-gray50',
  },
  /** NoShow */
  NoShow: {
    text: 'order_status_no_show',
    bgColor: 'wd-bg-gray80',
  },
}

/** 訂單標籤顯示狀態枚舉 */
export enum OrderTagDisplayStatus {
  /** 預訂完成 */
  BOOKED = 0,
  /** 預約完成 */
  RESERVED = 1,
  /** 已兌換 */
  REDEEMED = 2,
  /** 已送達 */
  ARRIVED = 3,
  /** 已開演 */
  THE_SHOW_STARTED = 4,
  /** 憑證可供下載 */
  CERT_CREATED = 5,
  /** 已報到 */
  IN_NEW = 6,
  /** 已報到/已過期 */
  REDEEM_NEW = 7,
  /** 已過期 */
  EXPIRED = 8,
  /** 已評論 */
  COMMENTED = 9,
  /** 訂單取消 */
  CANCEL = 10,
  /** 預約單取消 */
  RESERVATION_CANCEL = 11,
  /** 未出席 */
  NO_SHOW = 12,
}

/** https://github.com/funnow-docs/funnow-api-doc/pull/87 */
export const OrderTagDisplayStatusMap = Object.freeze({
  /** 0: 預訂完成 */
  [OrderTagDisplayStatus.BOOKED]: OrderTagStatusMap.Booked,
  /** 1: 預約完成 */
  [OrderTagDisplayStatus.RESERVED]: OrderTagStatusMap.Booked,
  /** 2: 已兌換 */
  [OrderTagDisplayStatus.REDEEMED]: OrderTagStatusMap.Redeemed,
  /** 3: 已送達 */
  [OrderTagDisplayStatus.ARRIVED]: OrderTagStatusMap.Arrived,
  /** 4: 已開演 */
  [OrderTagDisplayStatus.THE_SHOW_STARTED]: OrderTagStatusMap.TheShowStarted,
  /** 5: 憑證可供下載 */
  [OrderTagDisplayStatus.CERT_CREATED]: OrderTagStatusMap.CertCreated,
  /** 6: 已報到 */
  [OrderTagDisplayStatus.IN_NEW]: OrderTagStatusMap.InNew,
  /** 7: 已報到/已過期 */
  [OrderTagDisplayStatus.REDEEM_NEW]: OrderTagStatusMap.RedeemNew,
  /** 8: 已過期 */
  [OrderTagDisplayStatus.EXPIRED]: OrderTagStatusMap.Expired,
  /** 9: 已評論 */
  [OrderTagDisplayStatus.COMMENTED]: OrderTagStatusMap.Commented,
  /** 10: 訂單取消 */
  [OrderTagDisplayStatus.CANCEL]: OrderTagStatusMap.Cancel,
  /** 11: 預約單取消 */
  [OrderTagDisplayStatus.RESERVATION_CANCEL]: OrderTagStatusMap.Cancel,
  /** 12: 未出席 */
  [OrderTagDisplayStatus.NO_SHOW]: OrderTagStatusMap.NoShow,
})

export enum OrderStatus {
  /** 已建立 */
  Created,
  /** 交易中 */
  InTransaction,
  /** 交易完成 */
  Complete,
  /** 交易失敗 */
  Failed,
  /** 取消 */
  Cancel,
  /** Release */
  Release,
  /** 銷單 */
  FullRefund,
  /** 退訂 */
  PartialRefund,
  /** 已轉單 */
  Transfered,
  /** APP 銷單 */
  AppFullRefund,
  /** APP 退訂 */
  AppPartialRefund,
  /** 付款逾時 */
  PaymentTimeout,
}

export enum OrderListSeatConfirmStatus {
  /** 0 : 不顯示 */
  NONE,
  /** 1 : 尚未回覆是否出席 */
  NOT_CONFIRMED,
  /** 2 : 已保留訂位 */
  SEAT_CONFIRMED,
}

export enum OrderChargeStatus {
  /** 0: 未扣款 */
  NONE_CHARGE = 0,
  /** 1: 免費取消區間取消 */
  FREE_CANCEL = 1,
  /** 2: 非免費取消區間訂單取消/No-show 需罰款 */
  PENALTY = 2,
}

/**
 * 訂位確認狀態
 *
 * [figma link](https://www.figma.com/design/27NeZlJALzWDNKm98U2oQB/%E7%B4%94%E9%A0%90%E8%A8%82---FunNow-APP?node-id=9873-16202&m=dev)
 *
 * [jira api link](https://zoeknow.atlassian.net/browse/ZOEKIT-16187)
 */
export enum OrderDetailSeatConfirmStatus {
  /** 0: 尚未可確認 or 不需確認座位 */
  NOT_START,
  /** 1: 待確認 */
  PENDING,
  /** 2: 已確認 */
  CONFIRMED,
  /** 3: 已確認 (非免費取消區間) */
  CONFIRMED_WITH_PENALTY,
  /** @deprecated 4: 已確認 (方案不可取消) */
  CONFIRMED_WITH_NO_CANCEL,
}

export enum NotifyType {
  DEFAULT,
  EXTRA_EMAIL_SMS,
}

export enum AttendeeFormStatus {
  None,
  Unfinished,
  Finished,
}

export const AttendeeFormHint = Object.freeze({
  /** 尚未填寫 */
  [AttendeeFormStatus.Unfinished]: { text: 'orderdetail_form_alert', color: 'wd-text-red50' },
  /** 已填寫 */
  [AttendeeFormStatus.Finished]: { text: 'orderdetail_form_completed', color: 'wd-text-green70' },
  [AttendeeFormStatus.None]: { text: '', color: '' },
})

export type MovieOrder = {
  qty: number
  name: string
  description: string
}

/** Fun Coin 回饋類型 */
export enum FunCoinRewardType {
  /** 比例回饋 */
  Ratio,
  /** 固定金額回饋 */
  Fixed,
}

export type OrderListItem = {
  id: number
  type: number
  booking_time: string // '2025-06-06 07:00:00'
  checkout_time: string // ''
  end_time_text: string // '2025-06-06 08:30:00'
  used_time: string // ''
  status: OrderStatus
  display_status: OrderTagDisplayStatus
  attendee_status: AttendeeFormStatus
  branch_name: string
  product_name: string
  reviewed: number
  sales_mode: EdbSalesMode
  cover_image: string
  timezone: string
  has_cert: boolean
  gift_status: number
  reschedule: boolean
  delivery: Delivery
  movie?: Movie
  is_seat_only: boolean
  can_delete: boolean
  seat_confirm_status: OrderListSeatConfirmStatus
  review_bonus: number
}

export type OrderDetail = {
  additions: Addition[]
  address: string
  area: string
  attendee_expiry_time: string
  attendee_status: number
  bonus: number
  bonus_discount: number
  booking_time: string
  branch_cover_image: string
  branch_id: number
  branch_link: string
  branch_name: string
  branch_phone: string
  cancel_date: string
  cancel_reschedule_text: string
  cancel_rules: string[]
  cancelable: boolean
  cert: Cert
  checkout_time: string
  comment_count: number
  comment_reward: number
  comment_reward_amount: number
  contact_phone: string
  cover_image: string
  created_at: string
  cross_day_prices: CrossDayPrices[]
  cs_channel: string
  currency_id: number
  delivery: Delivery
  display_status: number
  domain_prefix: string
  duration: number
  duration_text: string
  end_time_text: string
  form_link: string
  fun_rewards_type: FunCoinRewardType
  fun_rewards_per: number
  fun_rewards_fixed: number
  gift_status: number
  has_paid?: boolean
  head_order_cust_num: number
  head_order_member_note: string
  head_order_remarks: Remark[]
  headcount_changeable: boolean
  id: number
  is_cust_num: boolean
  is_defer_payment: boolean
  is_gift: boolean
  is_paid_onsite: boolean
  is_seat_only: boolean
  is_payment_expired?: boolean
  is_vip: boolean
  lat: number
  lng: number
  member_level: number
  member_level_name: string
  member_note: string
  member_reward: string
  movie: Movie
  need_to_know: string
  ori_headcount: number
  occupation_count: number
  order_status: string
  orders_group_detail: OrdersGroupDetail
  orders_group_role: number
  original_checkout: string
  original_end_time_text: string
  original_time: string
  owner_id: number
  product: Product
  product_album_image: string
  product_detail_link: string
  promo: Promo
  promos: PromoV2[]
  rating: number
  redeem_code: string
  region_id: number
  remarks: Remark[]
  reschedulable: boolean
  reschedule_rules: string[]
  reschedule_status: number
  return_bonus: number
  review_content: string
  review_create_time: string
  review_rating: number
  review_tags: ReviewTag[]
  sales_mode: number
  short_link: string
  show_refund: boolean
  source: number
  status: number
  symbol: string
  symbol_code: string
  timezone: string
  total_amount: number
  txn_amount: number
  txn_info: TxnInfo
  type: number
  upgrade: Upgrade
  upgrades: Upgrade[]
  used_time: string
  vip_reward: string
  zip: string
  lead_time: string
  seat: Seat
  seat_confirm_status: OrderListSeatConfirmStatus | OrderDetailSeatConfirmStatus
  charge_details: {
    charge_status: OrderChargeStatus
    free_cancellation: {
      cancel_time: string
    }
    charge: {
      display_type: OrderChargeDisplayType
      is_success: boolean
      cancel_time: string
      charge_time: string
      primary_currency: {
        id: number
        code: string
        amount: number
        total_amount: number
      }
      second_currency: {
        id: number
        code: string
        amount: number
        total_amount: number
      }
      reserve_count: number
      refund_amount: number
    }
  }
  invoice_info?: InvoiceInfo | null
}

export enum OrderChargeDisplayType {
  /** 0: no-show */
  NO_SHOW,
  /** 1: 非免費取消區間取消訂單 */
  NON_FREE_CANCELLATION,
  /** 2: 折讓 */
  DISCOUNT,
  /** 3: 銷單 */
  FULL_REFUND,
  /** 4: 不執行扣款 */
  NO_CHARGE,
}

type Addition = {
  attn: string
  dscp: string
  id: number
  name: string
  price: number
  qty: number
  total_price: number
}

type Cert = {
  cert_path: string
  cert_status: number
}

type Delivery = {
  delivery_fee: number
  delivery_time_buffer: number
  estimated_delivery_time: string
  info: DeliveryInfo
  status: number
}

export type Seat = {
  id: number
  title: string
  content: string
  lang_for_usen?: string
}

type DeliveryInfo = {
  address: string
  establishment: string
  floor_building_number: string
  lat: number
  lng: number
  note: string
  pickup_type: number
}

type Movie = {
  booking_num: string
  cinema_name: string
  cust_num: number
  group_id: number
  hall: string
  name: string
  offline_refund_limit: number
  online_refund_limit: number
  ori_cust_num: number
  ori_tickets: MovieTicket[]
  poster: string
  seats: string[]
  status: number
  tickets: MovieTicket[]
  version: string
}

type MovieTicket = {
  description: string
  name: string
  qty: number
}

type OrdersGroupDetail = {
  products: ProductInfo[]
  remarks: string[]
  vip_rewards: string[]
}

type ProductInfo = {
  product_name: string
  quantity: number
}

type Product = {
  attn: string
  dscp: string
  id: number
  name: string
  price: number
  qty: number
  sub_item_prices: number[]
  sub_items: SubItem[][]
  total_price: number
  /** 是否有 No-Show 費用 */
  no_show_penalty: boolean
  /** 是否可取消 */
  cancelable: boolean
}

type SubItem = {
  desc: string
  free_qty: number
  id: number
  name: string
  price: number
  qty: number
  show_mode: number
}

type Promo = {
  discount: number
  is_multiple: boolean
  name: string
  promo_id: number
  refund: boolean
  refund_quantity: number
  usage_quantity: number
}

export type Remark = {
  content: string
  id: number
  sub_id: number | null
  sub_remarks?: Array<{
    id: number
    content: string
  }>
  title: string
  type: number
}

type PromoV2 = {
  discount: number
  has_refund: boolean
  is_multiple: boolean
  name: string
  promo_code_list_id: number
  promo_id: number
  refund_quantity: number
  usage_quantity: number
}

type ReviewTag = {
  tag_id: number
  tag_name: string
}

type TxnInfo = {
  amount: number
  currency_id: number
  refund: number
  symbol: string
  symbol_code: string
  txn_time: string
  payment_method_type_text: string
}

type TxnInfoAmount = {
  symbol_code: string
  amount: string
}

export type GiftTxnInfo = {
  total_amount: TxnInfoAmount
  product_amount: TxnInfoAmount
  bonus: string
  bonus_discount: null | TxnInfoAmount
  amount: TxnInfoAmount
  txn_time: string
  refund: null | TxnInfoAmount
  promo: null | {
    name: string
    discount: TxnInfoAmount
    refund: boolean
  }
  payment_method_type_text: string
}

type Upgrade = {
  price: number
  qty: number
  upgrade_desc: string
  upgrade_id: number
  upgrade_name: string
}

type CrossDayPrices = {
  date: string
  discount: number
}

export interface OrderCreationResponse {
  orderId: number
  link: string
  token: string
  is_need_bind_card: boolean
  rwg_type: number | null
}

// 稅金資訊介面
export interface TaxInfo {
  tax_id: string
  company_name: string
  receipt_company: string
}

// 訂單改期介面
export interface RescheduleParams {
  orderId: number
  token: string
  headcount?: number
}

export interface UpdateReschedulePayload {
  new_booking_time: string
  uid: string
  token: string
}

// 訂單更新介面
export interface UpdateOrderParams {
  token?: string
  member_note?: string
  email?: string
  tax_info?: TaxInfo
}

// 訂單來源介面
export interface OrderSourceData {
  source: number
  domain_prefix: string
}

// 訂單詳情介面
export interface OrderDetailParams {
  orderID: number | string
  token?: string
}

// 訂單狀態介面
export interface OrderStatusParams {
  orderID: string
  token?: string
}

// 取消訂單介面
export interface CancelOrderParams {
  token?: string
}

// 訂單取消資訊介面
export interface OrderCancelInfoParams {
  orderId: number
  token: string
}

// 訂單改期資訊介面
export interface OrderRescheduleInfoParams {
  orderId: number
  token: string
}
